import {clone, isTruthy} from "utils/DBUtils";
import ResourceField from "classes/ResourceField";
import SortManager from "classes/SortManager";
import FilterManager from "classes/FilterManager";

export const emptyPage = {
    page: 0,
    count: 0,
    total: 0,
    content: [],
    sortManager: new SortManager(),
    filterManager: new FilterManager()
};

const initialImageSortManager = new SortManager("name", "_created", "imageType");
initialImageSortManager.toggleSort("_created");

const initialImageFilterManager = new FilterManager();
// initialImageFilterManager.addNamedFilter("imageType", "original", FilterOperator.Equal);

let initialImagePage = clone(emptyPage);
initialImagePage.sortManager = initialImageSortManager;
initialImagePage.filterManager = initialImageFilterManager;

let initialChallengePage = clone(emptyPage);
initialChallengePage.sortManager = new SortManager("created", "publishStatus", "permalink", "startDate", "sponsoredType");
initialChallengePage.sortManager.toggleSort("created");


let initialPrizePage = clone(emptyPage);
initialPrizePage.sortManager = new SortManager("title", "description", "status", "_created");
initialPrizePage.sortManager.toggleSort("_created");

class ResourceState {
    resources = {};
    resourcePages = {
        Image: initialImagePage,
        Challenge: initialChallengePage,
        Prize: initialPrizePage
    };
    pendingSaves = {};
    saveErrors = {};

    constructor() {

    }

    getResource(id) {
        let resource = this.getRawResource(id);
        if (resource) {
            let keys = Object.keys(resource);
            let obj = {};
            for (let key of keys) {
                obj[key] = new ResourceField(this, id, key);
            }
            return obj;
        }

        return null;
    }

    getRawResource(id) {
        return isTruthy(this.resources[id]) ? this.resources[id] : null;
    }

    getSaveError(id, field) {
        return isTruthy(this.saveErrors[id + field]) ? this.saveErrors[id + field] : null;
    }

    getPage(resourceType) {
        return this.resourcePages[resourceType] ? this.resourcePages[resourceType] : clone(emptyPage)
    }

    getPageItems(pageName) {
        let page = this.getPage(pageName);
        return page.content.map((id) => this.resources[id]);
    }

    isSaving(id, field) {
        return isTruthy(this.pendingSaves[id + field]);
    }
}

export default ResourceState;


// WEBPACK FOOTER //
// ./public/classes/state/ResourceState.js